import React from 'react';
import {Box} from '@chakra-ui/react';
import {ColumnDef, createColumnHelper} from '@tanstack/react-table';
import {StatusBadge} from '../../Agents/StatusBadge';
import {getFieldLabel, FieldDefinition} from '../../../shared/fields/types';
import {CustomFieldMenu, EnrichedFieldCount} from './CustomFieldMenu';

// Shared column definitions for enrichment fields (AI, CRM, Role Count)
export const createEnrichmentColumns = <T extends FieldDefinition>() => {
  const columnHelper = createColumnHelper<T>();

  return [
    columnHelper.accessor((field) => field, {
      id: 'label',
      header: 'Field Name',
      size: 0,
      cell: (info) => {
        const field = info.getValue();
        return <Box whiteSpace="normal">{getFieldLabel(field)}</Box>;
      },
    }),
    columnHelper.accessor((field) => field.status, {
      id: 'status',
      header: 'Status',
      cell: (info) => {
        const status = info.getValue();
        return <StatusBadge status={status} />;
      },
    }),
    columnHelper.accessor((field) => field, {
      id: 'accountsEnriched',
      header: 'Accounts Enriched',
      size: 200,
      cell: (info) => {
        const field = info.getValue();
        return (
          <Box textColor="kgray.300">
            {field.status !== 'published' ? (
              ''
            ) : (
              <EnrichedFieldCount fieldDefinitionId={field.id} />
            )}
          </Box>
        );
      },
    }),
    columnHelper.accessor((field) => field.timestamp, {
      id: 'created',
      header: 'Created',
      size: 100,
      cell: (info) => {
        return (
          <Box textColor="kgray.300">
            {info.getValue().toLocaleDateString()}
          </Box>
        );
      },
    }),
    columnHelper.accessor((field) => field, {
      id: 'actions',
      header: '',
      size: 50,
      cell: (info) => {
        return <CustomFieldMenu fieldDefinition={info.getValue()} />;
      },
    }),
  ] as ColumnDef<T>[];
};
